import { Link, Stack } from "@mui/material";
import { AttachFile } from "@mui/icons-material";
import useUIBp from "../../../../../Hooks/useUIBoilerplate";
import { safeJSONParse } from "../../../Actions/utils";
import downloadChannelAttachment from "../../../Actions/downloadChannelAttachment";

// Renders the list of a Teams message attachments below its body. Each entry is
// a clip icon plus the attachment name styled as a link; clicking it triggers
// the channel attachment download. Used by both original messages and replies.
const MessageAttachments = ({ attachments }) => {
  const { auth, dispatch, settings } = useUIBp();

  const attachs = safeJSONParse(attachments, []);
  if (!Array.isArray(attachs) || attachs.length === 0) {
    return null;
  }

  return (
    <Stack spacing={0.5} sx={{ marginTop: 1 }}>
      {attachs.map((data, idx) => {
        const onClick = () => {
          dispatch(
            downloadChannelAttachment({
              ...auth,
              id: data.id,
              name: data.name,
              locale: settings.locale,
            })
          );
        };
        return (
          <Link
            key={data.id ?? idx}
            component="button"
            type="button"
            onClick={onClick}
            underline="hover"
            sx={{
              display: "inline-flex",
              alignItems: "center",
              gap: 0.5,
              width: "fit-content",
              fontSize: 13,
              cursor: "pointer",
            }}
          >
            <AttachFile sx={{ fontSize: 16 }} />
            {data.name}
          </Link>
        );
      })}
    </Stack>
  );
};

export default MessageAttachments;
